import { render, staticRenderFns } from "./mobile_register.vue?vue&type=template&id=6d1f8ccb&scoped=true"
import script from "./mobile_register.vue?vue&type=script&lang=js"
export * from "./mobile_register.vue?vue&type=script&lang=js"
import style0 from "./mobile_register.vue?vue&type=style&index=0&id=6d1f8ccb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1f8ccb",
  null
  
)

export default component.exports